// Reacties onder een item. Aankoppelpunt en gegevens: resources/views/comments/section.blade.php.
import {createApp} from 'vue';
import {api} from './comments/api.js';
import CommentsApp from './comments/CommentsApp.vue';
import {reducedMotion} from './comments/motion.js';

const element = document.getElementById('comments-app');

// Dezelfde regel als HasComments::commentCountLabel().
const countLabel = (count) => count === 0 ? 'Reageer als eerste' : (count === 1 ? '1 reactie' : count + ' reacties');

// Het aantal elders op de pagina (comments/components/count.blade.php, bijvoorbeeld in de header) bijwerken.
const updateCountLinks = (count) => document.querySelectorAll('[data-comments-count-label]').forEach((label) => {
    const link = label.closest('.comments-count-link');

    label.textContent = countLabel(count);
    link.classList.remove('comments-count-changed');
    void link.offsetWidth; // opnieuw afspelen
    link.classList.add('comments-count-changed');
});

if(element) {
    api.defaults.headers.common['X-CSRF-TOKEN'] = element.dataset.csrfToken;

    createApp(CommentsApp, {
        endpoint:        element.dataset.endpoint,
        initialComments: JSON.parse(element.dataset.comments || '[]'),
        canModerate:     element.dataset.canModerate === 'true',
        maxVisualDepth:  parseInt(element.dataset.maxVisualDepth, 10) || 1,
        staffName:       element.dataset.staffName || null,
        recaptchaKey:    element.dataset.recaptchaKey,
        onCountChange:   updateCountLinks
    }).mount(element);

    // Links naar de reacties op dezelfde pagina: soepel scrollen in plaats van springen.
    document.querySelectorAll('a[href="#reacties"]').forEach((link) => link.addEventListener('click', (event) => {
        event.preventDefault();
        document.getElementById('reacties').scrollIntoView({behavior: reducedMotion() ? 'auto' : 'smooth'});
        history.replaceState(null, '', '#reacties');
    }));
}
